<script setup lang="ts">
import { useTemplateRef } from 'vue';

import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';
import {
  PhxsgSlider as PhxsgCoreSlider,
  type PhxsgSliderProps as PhxsgCoreSliderProps,
} from '@sg-core/src/View/Components/Organisms/Slider';

import type { Swiper as SwiperType } from 'swiper/types';

const { navigation = true, scrollbar = false, ...props } = defineProps<PhxsgCoreSliderProps>();

const coreSliderRef = useTemplateRef('coreSliderRef');

defineExpose({
  get swiper() {
    return coreSliderRef.value?.swiper;
  },
});

defineEmits<{
  swiper: [swiper: SwiperType];
}>();
</script>

<template>
  <PhxsgCoreSlider v-bind="{ navigation, scrollbar, ...props }" ref="coreSliderRef" @swiper="$emit('swiper', $event)">
    <slot />

    <template #nav-prev="{ label }">
      <slot name="nav-prev" :label="label">
        <PhxsgButton icon-only size="sm" :icon="{ id: 'triangle-left', bidirectional: true }" :aria-label="label" />
      </slot>
    </template>

    <template #nav-next="{ label }">
      <slot name="nav-next" :label="label">
        <PhxsgButton icon-only size="sm" :icon="{ id: 'triangle-right', bidirectional: true }" :aria-label="label" />
      </slot>
    </template>

    <template #additional-content>
      <slot name="additional-content" />
    </template>
  </PhxsgCoreSlider>
</template>

<style src="./slider.css" />
